import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { ClassificacaoFaturamentoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-classificacao-faturamento-multiselect',
    templateUrl: './classificacao-faturamento-multiselect.component.html',
    styleUrls: ['./classificacao-faturamento-multiselect.component.less']
})
export class ClassificacaoFaturamentoMultiselectComponent implements OnInit {
    /** Classificações de Faturamento selecionadas */
    @Input() idsClassificacoesFaturamento: number[];
    /** Ao alterar a seleção das Classificações de Faturamento */
    @Output() idsClassificacoesFaturamentoChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de classificação nula ou seja, para filtrar registros que não possuem a classificação */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar a classificação nula */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção da classificação nula */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Classificação';
    @Input() checked = 'Classificação';
    @Input() checkedPlural = 'Classificações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma classificação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private classificacaoFaturamentoCrudHttpService: ClassificacaoFaturamentoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-classificacao-faturamento ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as Classificações de Faturamento para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.classificacaoFaturamentoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    // Adicionando as Classificações de Faturamento ao multiselect
                    if (entities) {
                        // Adicionando a opção de "Sem Classificação"
                        if (this.showNullOption) {
                            selects.push({
                                id: 0,
                                name: 'SEM CLASSIFICAÇÃO'
                            });
                        }

                        entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar as Classificações de Faturamentos', error);
                }
            );
    }

    /** Ao alterar a seleção da opção da natureza de venda nula */
    private onChangeNullOption() {
        this.nullOption = this.idsClassificacoesFaturamento.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção das Classificações de Faturamentos */
    onChange() {
        this.onChangeNullOption();
        this.idsClassificacoesFaturamentoChange.emit(this.idsClassificacoesFaturamento);
    }
}
